import { Component, Input, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, HostListener, ViewChild, ElementRef } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  PreflightUiResult,
  TwilioPreflightService
} from '@app/_core/services/twilio-preflight.service'
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  AudioDeviceTestService,
  AudioRecordingTestResult
} from './audio-device-test.service'
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { SecurityService } from '@app/_core/services/security.service';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { AppService } from '@app/_core/services/app.service';
interface AudioDeviceOption {
  deviceId: string;
  label: string;
}

interface PreflightSummary {
  overallStatus: 'Passed' | 'Failed' | 'Warning';
  callSid: string;
  turnRequired: string;
  selectedRegion: string;

  networkSpeed: string;
  networkType: string;
  effectiveNetworkType: string;
  browserNetworkRtt: string;

  packetLoss: string;
  jitter: string;
  rtt: string;
  mos: string;
  codec: string;
  warningCount: number;
  message: string;
}

@Component({
  selector: 'app-phone-settings',
  templateUrl: './phone-settings.component.html',
  styleUrl: './phone-settings.component.scss'
})
export class PhoneSettingsComponent implements OnInit, OnDestroy {
  useSoftPhone: boolean = false;
  isSummaryExpanded = true;
  audioInputDevices: MediaDeviceInfo[] = [];
  audioOutputDevices: MediaDeviceInfo[] = [];

  selectedInputDeviceId = 'default';
  selectedOutputDeviceId = 'default';

  isRunningDiagnostics = false;

  diagnosticResult: PreflightUiResult = {
    status: 'idle',
    message: ''
  };

  finalReport: any = null;
  preflightSummary: PreflightSummary | null = null;
  warnings: any[] = [];
  copySuccessMessage = '';

  private preflightSubscription?: Subscription;
  private tokenSubscription?: Subscription;
  private copySuccessMessageTimeout: any;
  txtphonenumber: any;
  isDisabled: boolean = false;

  isAudioTesting = false;
  isRecording = false;
  audioTestingButtonText = 'Recording...';

  recordedAudioUrl = '';

  audioTestResult: AudioRecordingTestResult = {
    status: 'idle',
    message: '',
    inputDeviceName: '',
    outputDeviceName: '',
    microphonePermission: '',
    recordingStatus: '',
    playbackStatus: '',
    browserSupport: ''
  };
  @ViewChild('phonesetting') phonesetting!: ElementRef;
  constructor(
    public bsModalRef: BsModalRef,
    private twilioPreflightService: TwilioPreflightService,
    private readonly audioDeviceTestService: AudioDeviceTestService,
    private cdRef: ChangeDetectorRef,
    private userService: UserService,
    private webStorageService: WebStorageService,
    private securityService: SecurityService,
    private mainController: MainControllerComponent,
    private appService: AppService,
  ) {
    this.LoginDetails();
    this.loadAudioDevices();
  }

  async ngOnInit(): Promise<void> {

  }

  async loadAudioDevices(): Promise<void> {
    try {
      const savedInputId = localStorage.getItem('deviceInputSelection');
      const savedOutputId = localStorage.getItem('deviceOutputSelection');

      this.selectedInputDeviceId = (savedInputId && savedInputId !== 'undefined') ? savedInputId : 'default';
      this.selectedOutputDeviceId = (savedOutputId && savedOutputId !== 'undefined') ? savedOutputId : 'default';


      await navigator.mediaDevices.getUserMedia({ audio: true });
      const devices = await navigator.mediaDevices.enumerateDevices();
      const deviceList =
        await this.audioDeviceTestService.loadAudioDevices(
          this.selectedInputDeviceId,
          this.selectedOutputDeviceId
        );

      this.audioInputDevices = deviceList.audioInputDevices;
      this.audioOutputDevices = deviceList.audioOutputDevices;

      this.selectedInputDeviceId = deviceList.selectedInputDeviceId;
      this.selectedOutputDeviceId = deviceList.selectedOutputDeviceId;

      // this.selectedInputDeviceId = this.audioInputDevices[0]?.deviceId || 'default';
      // this.selectedOutputDeviceId = this.audioOutputDevices[0]?.deviceId || 'default';
    } catch (error) {
      this.diagnosticResult = {
        status: 'failed',
        message: 'Microphone permission is required to load audio devices.',
        error
      };

      this.audioTestResult = {
        status: 'failed',
        message: 'Microphone permission denied. Please allow microphone access.',
        inputDeviceName: '',
        outputDeviceName: '',
        microphonePermission: 'Denied',
        recordingStatus: 'Not started',
        playbackStatus: 'Not started',
        browserSupport: 'Permission denied'
      };

    }
  }

  runDiagnostics(): void {
    if (!this.useSoftPhone) {
      this.diagnosticResult = {
        status: 'failed',
        message: 'Soft Phone is required.'
      };
      return;
    }

    this.isRunningDiagnostics = true;
    this.finalReport = null;
    this.preflightSummary = null;
    this.warnings = [];
    this.copySuccessMessage = '';

    this.diagnosticResult = {
      status: 'running',
      message: 'Getting Twilio token...'
    };

    this.tokenSubscription?.unsubscribe();
    this.preflightSubscription?.unsubscribe();

    this.tokenSubscription = this.twilioPreflightService.getVoiceToken().subscribe({
      next: ({ token }) => {
        this.preflightSubscription = this.twilioPreflightService
          .runPreflight(token)
          .subscribe({
            next: (result: PreflightUiResult) => {
              this.diagnosticResult = result;

              if (result.report) {
                this.finalReport = result.report;
                this.preflightSummary = this.buildPreflightSummary(result.report);
              }

              if (result.warnings?.length) {
                this.warnings = [...this.warnings, ...result.warnings];
              }

              if (
                result.status === 'completed' ||
                result.status === 'failed'
              ) {
                this.isRunningDiagnostics = false;
              }
            },
            error: (error) => {
              this.isRunningDiagnostics = false;

              if (!this.diagnosticResult.error) {
                this.diagnosticResult = {
                  status: 'failed',
                  message: 'Diagnostics failed.',
                  error
                };
              }
            },
            complete: () => {
              this.isRunningDiagnostics = false;
            }
          });
      },
      error: (error) => {
        this.isRunningDiagnostics = false;
        this.diagnosticResult = {
          status: 'failed',
          message: 'Unable to get Twilio access token.',
          error
        };
      }
    });
  }

  stopDiagnostics(): void {
    this.twilioPreflightService.stopPreflight();
    this.preflightSubscription?.unsubscribe();

    this.isRunningDiagnostics = false;
    this.diagnosticResult = {
      status: 'cancelled',
      message: 'Diagnostics cancelled.'
    };
  }

  buildPreflightSummary(report: any): PreflightSummary {
    const browserNetworkInfo = this.getBrowserNetworkInfo(report);

    const latestSample =
      report.latestSample ||
      report.stats?.[report.stats.length - 1] ||
      report.samples?.[report.samples.length - 1] ||
      null;

    const selectedIceCandidate =
      report.selectedIceCandidatePairStats ||
      report.selectedIceCandidatePair ||
      null;

    const warnings = report.warnings || this.warnings || [];

    const packetLoss =
      latestSample?.packetsLost ??
      latestSample?.packetsLostFraction ??
      latestSample?.packetLoss ??
      selectedIceCandidate?.packetsLost ??
      null;

    const jitter =
      latestSample?.jitter ??
      latestSample?.jitterBufferDelay ??
      selectedIceCandidate?.jitter ??
      null;

    const rtt =
      latestSample?.rtt ??
      latestSample?.roundTripTime ??
      selectedIceCandidate?.currentRoundTripTime ??
      selectedIceCandidate?.roundTripTime ??
      null;

    const mos =
      latestSample?.mos ??
      latestSample?.audioMos ??
      latestSample?.audioInputLevel ??
      null;

    const codec =
      latestSample?.codecName ||
      latestSample?.codec ||
      report.codec ||
      '-';

    let overallStatus: 'Passed' | 'Failed' | 'Warning' = 'Passed';
    let message = 'Diagnostics completed successfully. Soft phone looks ready.';

    if (warnings.length > 0 || report.isTurnRequired === true) {
      overallStatus = 'Warning';
      message = 'Diagnostics completed with warnings. Please review network, TURN, or audio details.';
    }

    if (report.error || report.status === 'failed') {
      overallStatus = 'Failed';
      message = 'Diagnostics failed. Please check microphone permission, network, or Twilio configuration.';
    }

    return {
      overallStatus,
      callSid: report.callSid || report.call_sid || '-',

      turnRequired:
        report.isTurnRequired === true
          ? 'Yes'
          : report.isTurnRequired === false
            ? 'No'
            : '-',

      selectedRegion:
        report.edge ||
        report.region ||
        report.selectedEdge ||
        '-',

      networkSpeed: browserNetworkInfo.networkSpeed,
      networkType: browserNetworkInfo.networkType,
      effectiveNetworkType: browserNetworkInfo.effectiveNetworkType,
      browserNetworkRtt: browserNetworkInfo.browserNetworkRtt,

      packetLoss: packetLoss !== null && packetLoss !== undefined ? `${packetLoss}` : '-',
      jitter: jitter !== null && jitter !== undefined ? `${jitter}` : '-',
      rtt: rtt !== null && rtt !== undefined ? `${rtt} ms` : '-',
      mos: mos !== null && mos !== undefined ? `${mos}` : '-',
      codec,
      warningCount: warnings.length,
      message
    };
  }

  getBrowserNetworkInfo(report?: any): {
    networkSpeed: string;
    networkType: string;
    effectiveNetworkType: string;
    browserNetworkRtt: string;
  } {
    const nav = navigator as any;

    const connection =
      nav.connection ||
      nav.mozConnection ||
      nav.webkitConnection;

    const reportNetworkType = this.getNetworkTypeFromPreflightReport(report);

    if (!connection) {
      return {
        networkSpeed: 'Not available',
        networkType: 'Not available',
        effectiveNetworkType: 'Not available',
        browserNetworkRtt: 'Not available'
      };
    }


    return {
      networkSpeed:
        connection.downlink !== undefined && connection.downlink !== null
          ? `${connection.downlink} Mbps`
          : 'Not available',

      networkType:
        connection.type ||
        reportNetworkType ||
        'Not available',


      effectiveNetworkType:
        connection.effectiveType || 'Not available',

      browserNetworkRtt:
        connection.rtt !== undefined && connection.rtt !== null
          ? `${connection.rtt} ms`
          : 'Not available'
    };
  }
  private getNetworkTypeFromPreflightReport(report: any): string | null {
    if (!report) {
      return null;
    }

    const possibleKeys = [
      'networkType',
      'network_type',
      'adapterType',
      'connectionType'
    ];

    return this.findFirstValueByKeys(report, possibleKeys);
  }

  private findFirstValueByKeys(
    obj: any,
    keys: string[],
    depth = 0,
    visited = new WeakSet<object>()
  ): string | null {
    if (!obj || typeof obj !== 'object' || depth > 8) {
      return null;
    }

    if (visited.has(obj)) {
      return null;
    }

    visited.add(obj);

    for (const key of keys) {
      if (
        obj[key] !== undefined &&
        obj[key] !== null &&
        obj[key] !== ''
      ) {
        return String(obj[key]);
      }
    }

    if (Array.isArray(obj)) {
      for (const item of obj) {
        const result = this.findFirstValueByKeys(
          item,
          keys,
          depth + 1,
          visited
        );

        if (result) {
          return result;
        }
      }
    } else {
      for (const value of Object.values(obj)) {
        const result = this.findFirstValueByKeys(
          value,
          keys,
          depth + 1,
          visited
        );

        if (result) {
          return result;
        }
      }
    }

    return null;
  }


  copyPreflightSummary(): void {
    if (!this.preflightSummary) {
      return;
    }

    const summaryText = `
Twilio Preflight Diagnostics Summary

Status: ${this.preflightSummary.overallStatus}
Message: ${this.preflightSummary.message}

Call SID: ${this.preflightSummary.callSid}
TURN Required: ${this.preflightSummary.turnRequired}
Selected Region/Edge: ${this.preflightSummary.selectedRegion}

Network Speed: ${this.preflightSummary.networkSpeed}
Network Type: ${this.preflightSummary.networkType}
Effective Network Type: ${this.preflightSummary.effectiveNetworkType}
Browser Network RTT: ${this.preflightSummary.browserNetworkRtt}

Packet Loss: ${this.preflightSummary.packetLoss}
Jitter: ${this.preflightSummary.jitter}
Twilio/WebRTC RTT: ${this.preflightSummary.rtt}
MOS/Audio Score: ${this.preflightSummary.mos}
Codec: ${this.preflightSummary.codec}
Warnings Count: ${this.preflightSummary.warningCount}
`;

    this.copyText(summaryText.trim(), 'Preflight Summary copied successfully.');
  }

  copyRawPreflightReport(): void {
    if (!this.finalReport) {
      return;
    }

    const reportText = JSON.stringify(this.finalReport, null, 2);
    this.copyText(reportText, 'Raw Preflight Report copied successfully.');
  }

  private copyText(text: string, successMessage: string): void {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.showCopyMessage(successMessage);
      }).catch(() => {
        this.fallbackCopyText(text, successMessage);
      });
    } else {
      this.fallbackCopyText(text, successMessage);
    }
  }

  private fallbackCopyText(text: string, successMessage: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand('copy');
      this.showCopyMessage(successMessage);
    } catch {
      this.showCopyMessage('Unable to copy report.');
    }

    document.body.removeChild(textarea);
  }

  private showCopyMessage(message: string): void {
    this.copySuccessMessage = message;

    this.copySuccessMessageTimeout = setTimeout(() => {
      this.copySuccessMessage = '';
    }, 3000);
  }


  ngOnDestroy(): void {
    this.tokenSubscription?.unsubscribe();
    this.preflightSubscription?.unsubscribe();
    this.twilioPreflightService.stopPreflight();
    this.audioDeviceTestService.cleanup();
    this.copySuccessMessageTimeout && clearTimeout(this.copySuccessMessageTimeout);
  }

  toggleSummary(): void {
    this.isSummaryExpanded = !this.isSummaryExpanded;
  }

  close(): void {
    this.stopDiagnostics();
  }

  ok(): void {
    this.close();
  }
  closePhoneSettingsPopup() {
    this.bsModalRef.hide();
  }
  numbersOnly(event) {
    const input = String.fromCharCode(event.keyCode);
    if (!/^[0-9+]*$/.test(input)) {
      event.preventDefault();
      alert("Enter Valid Phonenumber!")
    }
  }


  async runAudioRecordingTest(): Promise<void> {
    this.isAudioTesting = true;
    this.isRecording = false;
    this.audioTestingButtonText = 'Recording...';
    this.recordedAudioUrl = '';

    try {
      const response =
        await this.audioDeviceTestService.runAudioRecordingTest(
          this.selectedInputDeviceId,
          this.selectedOutputDeviceId,
          this.audioInputDevices,
          this.audioOutputDevices,
          recordingStartedResult => {
            this.isRecording = true;
            this.updateAudioAndDiagnosticResult(recordingStartedResult);
          },
          5000
        );

      this.isRecording = false;
      this.audioTestingButtonText = 'Playing...';
      this.recordedAudioUrl = response.recordedAudioUrl;
      this.updateAudioAndDiagnosticResult(response.result);
    } finally {
      this.isAudioTesting = false;
      this.isRecording = false;
      this.audioTestingButtonText = 'Recording...';
    }
  }

  stopRecording(): void {
    this.isRecording = false;
    this.isAudioTesting = false;
    this.diagnosticResult = {
      status: 'cancelled',
      message: 'audio diagnostics.'
    };

    this.audioDeviceTestService.stopRecording();

  }
  onStopClick(): void {
    console.log(this.isRunningDiagnostics, this.isAudioTesting);
    if (this.isRunningDiagnostics) {
      this.stopDiagnostics();
      return;
    }

    if (this.isAudioTesting) {
      this.stopRecording();
    }
  }
  private mapAudioStatusToDiagnosticStatus(
    status: AudioRecordingTestResult['status']
  ): PreflightUiResult['status'] {
    switch (status) {
      case 'passed':
        return 'completed';
      case 'failed':
        return 'failed';

      case 'warning':
        return 'running';
      case 'idle':
      default:
        return 'idle';
    }
  }
  private updateAudioAndDiagnosticResult(
    audioResult: AudioRecordingTestResult
  ): void {
    this.audioTestResult = audioResult;

    this.diagnosticResult = {
      status: this.mapAudioStatusToDiagnosticStatus(audioResult.status),
      message: audioResult.message
    };
  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }
  private LoginDetails() {
    this.userService.getUser(true, '').subscribe(data => {
      this.appService.setClientAppParams(data.Response.LoginParams);
      this.webStorageService.setItemInSessionStorage('loginParams', data.Response.LoginParams);
      this.useSoftPhone = data.Response.LoginParams.UseSoftPhone;
      this.appService.setUseSoftPhone(this.useSoftPhone);
      this.txtphonenumber = data.Response.User.PhoneNumbers[0].Number
    });
    const user: any = this.webStorageService.getItemFromSessionStorage('currentUser');
    for (var i = 0, l = user.PhoneNumbers.length; i < l; i++)
      this.txtphonenumber = user.PhoneNumbers[i].Number

    this.isDisabled = this.securityService.validateGrant('SoftphoneOnly');
    console.log('this.isDisabled', this.isDisabled);
  }
  onsoftphonechkChange(e: any) {
    this.useSoftPhone = e.target.checked;
  }
  onInputDeviceChange() {
    console.log('Selected Device ID:', this.selectedInputDeviceId);
    // Logic to update Twilio input goes here
    localStorage.setItem("deviceInputSelection", this.selectedInputDeviceId);
  }
  onOutputDeviceChange() {
    console.log('Selected Device ID:', this.selectedOutputDeviceId);
    // Logic to update Twilio input goes here
    localStorage.setItem("deviceOutputSelection", this.selectedOutputDeviceId);
  }
  SaveChanges() {
    console.log(this.useSoftPhone, 'useSoftPhone', this.txtphonenumber);
    localStorage.setItem("deviceInputSelection", this.selectedInputDeviceId);
    localStorage.setItem("deviceOutputSelection", this.selectedOutputDeviceId);
    this.userService.savePhoneNumber(this.useSoftPhone, this.txtphonenumber).subscribe(response => {
      console.log(response + "response save chagnes >>>>>>>>>");
      const loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
      loginParams.UseSoftPhone = this.useSoftPhone;
      this.appService.setClientAppParams(loginParams);
      this.appService.setUseSoftPhone(this.useSoftPhone);
      this.webStorageService.setItemInSessionStorage('loginParams', loginParams);
      this.appService.setPhoneClient('Twilio', this.useSoftPhone);
      this.mainController.resetSoftphoneinitialize();
      this.mainController.initializeSoftPhone();
      this.closePhoneSettingsPopup();
    })

  }
}